<template>
	<div>
		<BaseAccordionController
			:expand_accondion="true"
			:accordion_header="getStateWithParam('bicycle_lanes')"
		>
			<template v-slot:component>
				<MapController
					:map_data="data_map"
					:from_where="from_where"
					:icon_url="icon_url"
					:legent_button="false"
					class="accordion-card-middle"
				>
					<template
						v-for="(feature, featureind) in data_map.features"
					>
						<l-marker
							v-if="feature.geometry.type == 'Point'"
							:key="'marker-' + featureind"
							:lat-lng="
								getMarkerCoordinates(
									feature.geometry.coordinates
								)
							"
							:icon="getIconForMarker()"
						>
							<l-popup>
								<div class="item item-divider">
									<span style="font-weight: normal">{{
										getStateWithParam("bicycle_parking")
									}}</span>
									<div>{{ feature.properties.location }}</div>
								</div>
							</l-popup>
						</l-marker>
						<l-geo-json
							v-else
							:key="'feature-' + featureind"
							:geojson="feature"
							:name="'feature-' + featureind"
							:options-style="styleFunction(featureind)"
							:attribution="'feature-' + featureind"
						></l-geo-json>
					</template>
				</MapController>
			</template>
		</BaseAccordionController>
	</div>
</template>

<script>
import MapController from "@/components/cards/MapController.vue";
import { LGeoJson, LMarker, LPopup } from "vue2-leaflet";
import transport from "@/config/api/api_events/transport.js";
import map_helper from "@/config/js_helper/map_helper.js";
export default {
	name: "Bicycle",
	components: {
		//MapCard
		MapController,
		LMarker,
		LPopup,
		LGeoJson,
	},
	data() {
		return {
			from_where: 2,
			data_map: {},
			icon_url: require("@/assets/img/new_icons/bicikleta.svg"),
		};
	},
	created() {
		this.getBicyclesFromCall();
	},
	methods: {
		getBicyclesFromCall() {
			transport
				.getBicycles()
				.then((response) => {
					this.data_map = response;
					this.$store.state.active_loader = false;
				})
				.catch((error) => {
					this.$store.state.active_loader = false;
					console.log("There was an error:", error);
				});
		},
		getStateWithParam(param) {
			return this.$store.getters.getLanguageParameters(param);
		},
		getMarkerCoordinates(marker) {
			return [marker[1], marker[0]];
		},
		getIconForMarker() {
			return map_helper.getIcon(this.icon_url);
		},
		styleFunction(index) {
			let styles = map_helper.getLineStrokeStyle(
				this.data_map.features,
				this.from_where,
				index
			);
			return styles;
		},
	},
};
</script>

<style scope lang="scss" src="./Bicycle.scss"></style>
